export function WordAlternativesPopover({
  word,
  x,
  y,
  alternatives,
  loading,
  onClose,
  onPickAlternative,
}: {
  word: string
  x: number
  y: number
  alternatives: string[]
  loading: boolean
  onClose: () => void
  onPickAlternative: (alt: string) => void
}) {
  return (
    <>
      <div className="fixed inset-0 z-40" onClick={onClose} />
      <div
        className="fixed z-50 rounded-xl border border-app bg-surface/95 backdrop-blur-md shadow-token-lg overflow-hidden min-w-[150px] animate-scale-in"
        style={{ left: x, top: y }}
      >
        <div className="px-3 py-1.5 border-b border-app bg-surface-2/80">
          <span className="text-[10px] font-bold uppercase tracking-wider text-subtle">Alternatives for &ldquo;{word}&rdquo;</span>
        </div>
        {loading ? (
          <div className="px-3 py-3 flex items-center gap-2 text-[12px] text-subtle">
            <span className="h-2 w-2 rounded-full bg-brand animate-pulse" />
            Loading…
          </div>
        ) : alternatives.length === 0 ? (
          <div className="px-3 py-2 text-[12px] text-subtle">No alternatives found</div>
        ) : (
          alternatives.map((alt) => (
            <button
              key={alt}
              type="button"
              onClick={() => onPickAlternative(alt)}
              className="w-full text-left px-3 py-2 text-[13px] font-medium text-app hover:bg-[var(--accent-soft)] hover:text-[var(--accent-ink)] transition-all duration-100 border-b border-app last:border-0 cursor-pointer active:scale-[0.99] select-none"
              dir="auto"
            >
              {alt}
            </button>
          ))
        )}
      </div>
    </>
  )
}
